import { QueryService, LocalStorageService } from '../../../services'
import i18n from '../../../config/i18next'

const getCurrentLanguage = () => {
  const language = i18n.language

  return language ? language.substring(0,2) : null
}

 const getQueryFirstPage = (query, subclientId, resultsPerPage, type, typeSearch, pais) => {
  return new Promise(async (resolve, reject) => {
    const language = getCurrentLanguage()

    await QueryService.create(query, subclientId, resultsPerPage, language, type, typeSearch, pais)
      .then(response => resolve(response.data))
      .catch(err => reject({ error: true }))
  })
}

export default getQueryFirstPage;
